import { RepositoryFactory, EnvironmentType } from './repositories/RepositoryFactory';

/**
 * Configura el entorno de la aplicación para los repositorios
 * @param useRealApi - Si es true, se usará la API real en lugar de los mocks
 */
export function configureEnvironment(useRealApi: boolean = false): void {
  const env: EnvironmentType = useRealApi ? 'production' : 'development';
  RepositoryFactory.setEnvironment(env);
}

/**
 * Inicializa la configuración de la aplicación
 */
export function initializeApp(): void {
  // Por defecto, usamos el entorno de producción (API real) a menos que se indique lo contrario
  // Esto es para asegurar que se use la API real cuando la aplicación está en producción
  const useRealApiFromStorage = localStorage.getItem('useRealApi');
  
  // Si hay una configuración en localStorage, usamos esa, de lo contrario, usamos producción
  const useRealApi = useRealApiFromStorage !== null
    ? useRealApiFromStorage === 'true'
    : process.env.NODE_ENV === 'production' || process.env.REACT_APP_USE_REAL_API === 'true' || true;
  
  configureEnvironment(useRealApi);
} 